import { Link } from "react-router-dom";
import { Star, MapPin, Coins, Clock } from "lucide-react";
import { CATEGORY_LABELS, formatDate } from "@/lib/data";

export function StudioCard({ studio, index = 0 }) {
  const next = studio.next_session;
  return (
    <Link
      to={`/studyo/${studio.id}`}
      data-testid={`studio-card-${studio.id}`}
      className="group block animate-fade-up overflow-hidden rounded-2xl border border-[#E5E0D8] bg-white transition-shadow hover:shadow-[0_12px_40px_-12px_rgba(45,41,38,0.25)]"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="relative h-52 overflow-hidden">
        <img
          src={studio.cover}
          alt={studio.name}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-white/85 px-3 py-1 text-xs font-medium capitalize text-[#2D2926] backdrop-blur">
          {CATEGORY_LABELS[studio.category]}
        </span>
        <span className="absolute right-3 top-3 flex items-center gap-1 rounded-full bg-[#2D2926]/80 px-2.5 py-1 text-xs font-medium text-white backdrop-blur">
          <Star className="h-3 w-3 fill-[#E8DED1] text-[#E8DED1]" /> {studio.rating}
        </span>
      </div>
      <div className="p-5">
        <h3 className="font-display text-xl font-semibold leading-snug">{studio.name}</h3>
        <div className="mt-1.5 flex items-center gap-1.5 text-sm text-[#5C5856]">
          <MapPin className="h-3.5 w-3.5" /> {studio.region}
          <span className="text-[#C9BFB1]">·</span> {studio.distance_km} km
        </div>
        <div className="mt-4 flex items-center justify-between border-t border-[#F0EAE0] pt-4">
          <div className="text-sm text-[#5C5856]">
            {next ? (
              <span className="flex items-center gap-1.5"><Clock className="h-3.5 w-3.5" /> {formatDate(next.date)} · {next.start_time}</span>
            ) : (
              <span>Yakında seans</span>
            )}
          </div>
          <div className="flex items-center gap-1 font-semibold text-[#8C6A5D]">
            <Coins className="h-4 w-4" /> {studio.credit_price}
          </div>
        </div>
      </div>
    </Link>
  );
}
